import doCalculateTicketTypeCacheKey from './original/calculateTicketTypeCacheKey';
import { selectTicketTypes } from '%paysera_seat_selection/js/seatSelection/redux/component/orm/selectors';

function calculateTicketTypeCacheKey() {
    return (dispatch, getState) => {
        const seatSelectionTicketTypes = selectTicketTypes(getState());

        seatSelectionTicketTypes.forEach((seatSelectionTicketType) => {
            dispatch(doCalculateTicketTypeCacheKey({ seatSelectionTicketType }));
        });
    };
}

export default calculateTicketTypeCacheKey;
